import { render } from "./ListGatewaysSetting.vue?vue&type=template&id=590c4e38"
import script from "./ListGatewaysSetting.vue?vue&type=script&lang=js"
export * from "./ListGatewaysSetting.vue?vue&type=script&lang=js"

import "./ListGatewaysSetting.vue?vue&type=style&index=0&id=590c4e38&lang=scss"

import exportComponent from "F:\\Projeler\\vuejs\\eticposdashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__